import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const OfferItemWrapper = styled.div<{ backgroundColor?: string }>`
  background: ${props => (typeof props.backgroundColor !== 'undefined' ? props.backgroundColor : 'black')};
  border-radius: 5px;
  margin: 5px 0;
  padding: 15px 15px 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const OfferItemTop = styled.div`
  display: flex;
  align-items: center;

  & picture {
    height: 15px;
  }
`;

export const OfferItemHeading = styled.h4<{
  textColour: string | null;
}>`
  font-family: var(--ogm-font-family-2);
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 22px;
  color: ${props => (props.textColour === 'light' ? 'var(--oc-text-white)' : 'var(--ogm-text-body)')};
  margin: 11px 0 10px;
`;

export const OfferItemDescription = styled.p<{
  textColour: string | null;
}>`
  margin: 5px 0;
  color: ${props => (props.textColour === 'light' ? 'var(--oc-text-white)' : 'var(--ogm-text-body)')};
  font-family: var(--ogm-font-family-2);
  font-style: normal;
  font-weight: normal;
  font-size: 8px;
  line-height: 10px;
  mix-blend-mode: normal;
`;

export const OfferItemCta = styled.button`
  text-decoration: none;

  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 38px;
  background: var(--ogm-grid-selected-cell-bg-color);
  border-radius: 5px;

  font-family: var(--ogm-font-family-2);
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 22px;
  color: var(--oc-text-white);
  text-align: center;
  cursor: pointer;
`;

export const OfferItemLabel = styled.span<{
  textColour: string | null;
}>`
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
  font-family: var(--ogm-font-family-2);
  font-style: normal;
  font-weight: bold;
  font-size: 9px;
  line-height: 12px;
  color: ${props => (props.textColour === 'light' ? 'var(--oc-text-white)' : 'var(--ogm-text-body)')};
  padding: 2px 5px 1px 5px;
  text-transform: uppercase;
  margin-left: 10px;
`;

export const offerBookmakerImg = css`
  object-fit: contain;
  display: inline-block;
`;

export const OfferResponsibleGamingContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 5px;
  transform: scale(0.6);
  position: relative;
  left: -57px;
  margin-top: auto;

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      left: -52px;
    }
  }
`;
